export const ROUTE_CONFIGURACION_TIPO_CONVENIO = 'convenios:configuracion:tipo-convenio'

export const ROUTE_CONFIGURACION_NIVEL_APROBACION = 'convenios:configuracion:nivel-aprobacion'
